const IconArrowDown = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.675 11.05L7.5 7.23333L11.325 11.05L12.5 9.875L7.5 4.875L2.5 9.875L3.675 11.05Z"
      fill="#736967"
    />
  </svg>
);

export default IconArrowDown;
